export default __webpack_public_path__ + "static/media/uploadFileLight.14ede7a1.svg";